<gd-status-label [color]="color" [text]="text" [fluid]="fluid" [noShrink]="noShrink" [maxWidth]="140">
</gd-status-label>
